import { RemoteConfig } from '@trendyol/sc-utils/';
import ForgotPasswordService from '@/services/ForgotPasswordService';

export const remoteConfig = new RemoteConfig();
export const forgotPasswordService = new ForgotPasswordService();
